module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="dynamic-widget-tab" id="rectangle">\n    <p class="dynamic-widget-tab-label" font-size="12px">Product</p>\n</div>\n<div class="group-overlay"></div>\n<div class="group"></div>\n\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/shared/ui/experience/widgets/dynamicProductWidget/DynamicProductWidgetLayout.tpl
// module id = 1468
// module chunks = 0